import { Card, CardContent } from '@/components/ui/card'
import React from 'react'

const Success = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
            <Card className="max-w-md w-full bg-white rounded-2xl shadow-lg">
                <CardContent className="p-8 text-center">
                    <div className="mb-6">
                        <div className="w-16 h-16 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center">
                            <svg
                                className="w-8 h-8 text-green-500"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </div>
                        <h1 className="text-2xl font-bold text-green-600 mb-2">
                            Payment Successful!
                        </h1>
                        <p className="text-gray-600">
                            Your payment has been processed successfully.
                        </p>
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}

export default Success